import FooterPublicCommon from './containers/footerPublicCommon'

export {default as FooterPublicCommonLayout} from './components/footerPublicCommonLayout'

export default FooterPublicCommon
